"use client";

import { WebClientSize } from "@faire/web-api--source/indigofair/data/WebClientSize";
import React from "react";

import { useGetCurrentSDUIClientSize } from "@faire/retailer/components/SDUI/__internal__/Viewport/useGetCurrentSDUIClientSize";

export const SDUIViewportHandler = ({
  viewports = [],
  children,
}: {
  viewports: (keyof typeof WebClientSize)[];
  children: React.ReactNode;
}) => {
  const sduiClientSize = useGetCurrentSDUIClientSize();
  if (viewports.length > 0 && !viewports.includes(sduiClientSize)) {
    return null;
  }

  return <>{children}</>;
};
